// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "./ToDoReact.PNG",
    title: "To Do Book",
    description: "Un clásico ToDo App con almacenamiento en localStorage",
    tech_stack: "ReactJS, Bootstrap",
    github_url: "https://github.com/YuliaGV/to-do-book",
    demo_url: "https://to-do-book.web.app/",
  },
  {
    img: "./MiEmpresa.png",
    title: "MiEmpresa - Sistema POS",
    description: "Sistema POS desarrollado con PHP y MySQL bajo el modelo MVC. Actualmente en desarrollo",
    tech_stack: "PHP, JavaScript(Ajax), MySQL, HTML, Bootstrap",
    github_url: "https://github.com/YuliaGV/MiEmpresa-POS",
    demo_url: "#",
  },
  {
    img: "./TiendaSyM.png",
    title: "Tienda SyM",
    description:
      "Mi primer sitio web :3 maquetación para un emprendimiento familiar",
    tech_stack: "HTML, CSS",
    github_url: "https://github.com/YuliaGV/TiendaSyM",
    demo_url: "https://yuliagv.github.io/TiendaSyM/",
  },
  {
    img: "./InfoClima.png",
    title: "Infoclima App",
    description:
      "Aplicación del clima consumiendo la API de OpenWeatherMap",
    tech_stack: "React, MaterialUI",
    github_url: "https://github.com/YuliaGV/infoclima-app",
    demo_url: "https://infoclima-app.web.app/",
  },
  {
    img: "./Learning.PNG",
    title: "LearningTube",
    description:
      "Una copia de Youtube antiguo. Consta de autenticación y crud de videos organizados por categorías",
    tech_stack: "PHP, MySQL",
    github_url: "https://github.com/YuliaGV/LearningTube",
    demo_url: "#",
  },
  {
    img: "./MediaBank.PNG",
    title: "Media-Bank",
    description:
      "Consumo de diferentes APIs gratuitas para la obtención de recursos como imágenes, gifs y letras de canciones",
    tech_stack: "HTML, CSS, Bootstrap, JavaScript",
    github_url: "https://github.com/YuliaGV/Media-Bank",
    demo_url: "https://yuliagv.github.io/Media-Bank/index.html",
  },
  {
    img: "./EnjoyCooking.png",
    title: "Enjoy Cooking",
    description:
      "App de recetas consumiendo la API de TheMealDB",
    tech_stack: "ReactJS, Bootstrap",
    github_url: "https://github.com/YuliaGV/enjoy-cooking-app",
    demo_url: "https://enjoy-cooking-app.web.app/",
  },
  {
    img: "./RapReggae.png",
    title: "Rap-Reggae Festival",
    description:
      "Maquetación de sitio promocional para un festival de música",
    tech_stack: "HTML, Saas",
    github_url: "https://github.com/YuliaGV/Rap-Reggae-Fest",
    demo_url: "https://yuliagv.github.io/Rap-Reggae-Fest/",
  },
  {
    img: "./TikFood.PNG",
    title: "TikFood -ordena comida (en desarrollo)",
    description:
      "App para ordenar comida con almacenamiento en base de datos MySQL",
    tech_stack: "HTML, CSS, PHP, MySQL",
    github_url: "https://github.com/YuliaGV/tikfood-ordenacomida",
    demo_url: "#",
  },
  
  {
    img: "./MyDrinksSite.png",
    title: "My Drinks App",
    description:
      "Recetas de bebidas con consumo de la API TheCoctailDB y almacenamiento de favoritos en LocalStorage",
    tech_stack: "React, Bootstrap",
    github_url: "https://github.com/YuliaGV/mydrinks-site",
    demo_url: "https://mydrinks-app.web.app/",
  }
  

];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "./html_icon.svg",
    name: "HTML",
  },
  {
    img: "./css_icon.svg",
    name: "CSS",
  },
  {
    img: "./js_icon.svg",
    name: "JavaScript",
  },
  {
    img: "./react_icon.svg",
    name: "React",
  },
  {
    img: "./php_icon.svg",
    name: "PHP",
  },
  {
    img: "./mysql_icon.svg",
    name: "MySQL",
  }
];
